<template>
    <div class="main mineStudent_css">
        <p>
            <span class="hover" @click="$router.push('/consultant/minestudent')">我的学生</span>
            > {{name}} - {{sexName}} - {{school}}{{parameter}}
        </p>
        <div class="inner">
            <ul class="nav">
                <router-link v-for="(item,index) in nav" :key="index" tag="li" :to="{path:item.path}">
<!--                    <img :src="item.src" alt="">-->
                    <div class="imgBox"></div>
                    {{item.name}}
                </router-link>
            </ul>
            <div class="right_content">
                <router-view @event1="change($event)"></router-view>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            name:'',
            school:'',
            sexName:'',
            parameter:'',
            nav: [
                { name: '学生信息', idx: '0', path: '/consultant/minestudent/main/studentMessage',src:'/imgs/xueyezixun/consultant/student/mine/main/icon_01.png' },
                { name: '规划内容', idx: '1', path: '/consultant/minestudent/main/planningContent',src:'/imgs/xueyezixun/consultant/student/mine/main/icon_02.png' },
                { name: '计划执行', idx: '2', path: '/consultant/minestudent/main/implement/targetsplit',src:'/imgs/xueyezixun/consultant/student/mine/main/icon_03.png' },
                { name: '咨询记录', idx: '3', path: '/consultant/minestudent/main/consultationRecord',src:'/imgs/xueyezixun/consultant/student/mine/main/icon_04.png' },
                { name: '数据分析', idx: '4', path: '/consultant/minestudent/main/dataAnalysis/grade',src:'/imgs/xueyezixun/consultant/student/mine/main/icon_05.png' },
                { name: '成长档案', idx: '5', path: '/consultant/minestudent/main/growthFile',src:'/imgs/xueyezixun/consultant/student/mine/main/icon_06.png' },
            ],
          query:''
        }
    },
    methods:{
        getData(){
            
            this.$ajax.post(this.G_acapi + this.ports.consultant.student.new.getStudentDetail,{
                studentId:sessionStorage.getItem("myStudentStudentId")
            },{
                headers: {
                    token: window.sessionStorage.getItem('ymtxToken')
                }
            }).then(res=>{
                if(res.data.code==2000){
                    console.log(res)
                    let {name,sexName,school} = res.data.data
                    this.name=name;
                    this.school=school;
                    this.sexName=sexName;
                }else{
                    this.$message({
                        message: res.data.msg,
                        type: 'error'
                    });
                }
            })
        },
        change(data){
            this.parameter=data
        }
    },
    mounted() {
      if(window.sessionStorage.mineStudentData){
        this.query=JSON.parse(window.sessionStorage.mineStudentData)
      }else{
        window.sessionStorage.mineStudentData=JSON.stringify(this.$route.query)
        this.query=this.$route.query
      }
        this.getData()
    }
}
</script>

<style scoped lang="less">
*{
    margin: 0;
    padding: 0;
}

.main{
    width: 1200px;
    margin:0 auto;
    &>p{
        line-height: 40px;
        font-size: 16px;
    }
    .hover{
        cursor: pointer;
        &:hover{
            color:#0A9BF0;
        }
    }
    .inner {
        display: flex;
        width: 1200px;
        margin: 0 auto;
        .nav {
            width: 146px;
            margin-right: 20px;
            text-align: center;
            font-size: 14px;
            li {
                line-height: 40px;
                background-color: #fff;
                cursor: pointer;
                display: flex;
                justify-content: center;
                align-items: center;
                border-bottom: 1px solid rgba(61, 144, 246, 0.14);
                colro: #333;
                .imgBox {
                    width: 20px;
                    height: 20px;
                    margin-right: 15px;
                }
                &:last-child {
                    border: none;
                }
                &:nth-child(1) .imgBox{
                    background: url("/imgs/xueyezixun/consultant/student/mine/main/icon_01.png") no-repeat center center;
                }
                &:nth-child(2) .imgBox{
                    background: url("/imgs/xueyezixun/consultant/student/mine/main/icon_02.png") no-repeat center center;
                }
                &:nth-child(3) .imgBox{
                    background: url("/imgs/xueyezixun/consultant/student/mine/main/icon_03.png") no-repeat center center;
                }
                &:nth-child(4) .imgBox{
                    background: url("/imgs/xueyezixun/consultant/student/mine/main/icon_04.png") no-repeat center center;
                }
                &:nth-child(5) .imgBox{
                    background: url("/imgs/xueyezixun/consultant/student/mine/main/icon_05.png") no-repeat center center;
                }
                &:nth-child(6) .imgBox{
                    background: url("/imgs/xueyezixun/consultant/student/mine/main/icon_06.png") no-repeat center center;
                }
                img {
                    display: block;
                    margin-right: 15px;
                }
            }
            .router-link-active {
                color: #fff;
                background-color: #3D90F6;
                &:nth-child(1) .imgBox{
                    background: url("/imgs/xueyezixun/consultant/student/mine/main/icon_w01.png") no-repeat center center;
                }
                &:nth-child(2) .imgBox{
                    background: url("/imgs/xueyezixun/consultant/student/mine/main/icon_w02.png") no-repeat center center;
                }
                &:nth-child(3) .imgBox{
                    background: url("/imgs/xueyezixun/consultant/student/mine/main/icon_w03.png") no-repeat center center;
                }
                &:nth-child(4) .imgBox{
                    background: url("/imgs/xueyezixun/consultant/student/mine/main/icon_w04.png") no-repeat center center;
                }
                &:nth-child(5) .imgBox{
                    background: url("/imgs/xueyezixun/consultant/student/mine/main/icon_w05.png") no-repeat center center;
                }
                &:nth-child(6) .imgBox{
                    background: url("/imgs/xueyezixun/consultant/student/mine/main/icon_w06.png") no-repeat center center;
                }



            }
        }

        .right_content {
            // flex: 1;
            width: 1034px;
            box-sizing: border-box;
            height: 100%;

        }
    }

}

</style>
<style lang="less">
.mineStudent_css textarea{
  min-height: 128px !important;
}
</style>